import React, { createContext, useState } from "react";

export const TestRequestContext = createContext<{
  // TODO improve type => testRequestObj shape is known
  testRequestObj: Record<string, any>;
  testRequestTitleSuffix: string;
  testRequestHistorical: boolean;
  updateTestRequestObj: (newTestRequestObj: Record<string, any>) => void;
  updateTestRequestTitleSuffix: (newTestRequestTitleSuffix: string) => void;
  updateTestRequestHistorical: (newTestRequestHistorical: boolean) => void;
  resetTestRequestContext: () => void;
}>({
  testRequestObj: {},
  testRequestTitleSuffix: "",
  testRequestHistorical: false,
  updateTestRequestObj: (newTestReqObj) => {},
  updateTestRequestTitleSuffix: (newTestReqTitleSuffix) => "",
  updateTestRequestHistorical: (newTestReqHistorical) => false,
  resetTestRequestContext: () => {},
});

const TestRequestProvider: React.FunctionComponent = (props: any) => {
  const [testRequestObj, setTestRequestObj] = useState({});
  const [testRequestTitle, setTestRequestTitle] = useState("");
  const [testRequestHistorical, setTestRequestHistorical] = useState(false);

  const updateTestRequestObj = (newTestRequest: any) => {
    setTestRequestObj(newTestRequest);
  };
  const updateTestRequestTitleSuffix = (newTestRequestTitle: string) => {
    setTestRequestTitle(newTestRequestTitle);
  };
  const updateTestRequestHistorical = (newTestRequestHistorical: boolean) => {
    setTestRequestHistorical(newTestRequestHistorical);
  };
  const resetTestRequestContext = () => {
    setTestRequestObj({});
    setTestRequestTitle("");
    setTestRequestHistorical(false);
  };
  const { children } = props;

  return (
    <TestRequestContext.Provider
      value={{
        testRequestObj,
        testRequestTitleSuffix: testRequestTitle,
        testRequestHistorical,
        updateTestRequestObj,
        updateTestRequestTitleSuffix,
        updateTestRequestHistorical,
        resetTestRequestContext,
      }}
    >
      {children}
    </TestRequestContext.Provider>
  );
};

export default TestRequestProvider;
